import { render, staticRenderFns } from "./UserAddScreen.vue?vue&type=template&id=843d9220&scoped=true&"
import script from "./UserAddScreen.vue?vue&type=script&lang=js&"
export * from "./UserAddScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843d9220",
  null
  
)

export default component.exports